module.exports = __webpack_public_path__ + "img/illustration-erro.2e143bcc.svg";